import { render, staticRenderFns } from "./AvatarDialog.vue?vue&type=template&id=c88757e2&scoped=true&"
import script from "./AvatarDialog.vue?vue&type=script&lang=js&"
export * from "./AvatarDialog.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDialog.vue?vue&type=style&index=0&id=c88757e2&lang=scss&scoped=true&"
import style1 from "./AvatarDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88757e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
